import { render, staticRenderFns } from "./POIs.vue?vue&type=template&id=24f211f4&"
import script from "./POIs.vue?vue&type=script&lang=js&"
export * from "./POIs.vue?vue&type=script&lang=js&"
import style0 from "./POIs.vue?vue&type=style&index=0&id=24f211f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports